import { render } from "./Formato2011.vue?vue&type=template&id=50eb8a74&scoped=true"
import script from "./Formato2011.vue?vue&type=script&lang=js"
export * from "./Formato2011.vue?vue&type=script&lang=js"

import "./Formato2011.vue?vue&type=style&index=0&id=50eb8a74&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50eb8a74"]])

export default __exports__